const actions = {
  LOGIN: "sendLoginCredentials",
  REGISTER: "sendRegistrationData",
  LOGOUT: "deleteAuthenticationToken",
  CHECK_IF_AUTHORIZED: "checkUserIsAuthorized",
  FINISH_REGISTRATION: "postFinishRegistrationCode",
  TWO_FACTOR_LOGIN: "postTwoFactorLoginCode",
  POST_IS_ALIVE: "postIsAlive"
};

export default actions;
